import React, { useState, useEffect } from 'react';

const SECTIONS = [
  { id: 'welcome', label: 'Welcome', icon: '👋' },
  { id: 'company', label: 'Who We Are', icon: '🏢' },
  { id: 'employment', label: 'Employment Policies', icon: '📋' },
  { id: 'compensation', label: 'Compensation & Payroll', icon: '💰' },
  { id: 'app', label: 'App Requirements', icon: '📱' },
  { id: 'leads', label: 'Lead & Territory Rules', icon: '📍' },
  { id: 'estimates', label: 'Estimate Guidelines', icon: '📐' },
  { id: 'documentation', label: 'Documentation Standards', icon: '📸' },
  { id: 'dress', label: 'Dress Code & Uniforms', icon: '👕' },
  { id: 'vehicle', label: 'Vehicle & Equipment', icon: '🚗' },
  { id: 'social', label: 'Social Media & Confidentiality', icon: '🔒' },
  { id: 'drug', label: 'Drug-Free Workplace', icon: '🚫' },
  { id: 'safety', label: 'Safety Policy', icon: '⛑️' },
  { id: 'help', label: 'How to Get Help', icon: '🤝' },
];

export default function HandbookPage({ standalone = false }: { standalone?: boolean }) {
  const [active, setActive] = useState('welcome');
  const [isMobile, setIsMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const activeSection = SECTIONS.find(s => s.id === active);

  const handleNavClick = (id: string) => {
    setActive(id);
    setDrawerOpen(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '100vh', background: '#0F1923', fontFamily: 'Arial, sans-serif' }}>

      {/* Mobile Header */}
      {isMobile && (
        <div style={{ background: '#0a1118', borderBottom: '1px solid #1E3A5F', padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100 }}>
          <div>
            <img src="/logo-white.png" alt="McMullen Browne" style={{ height: 32, width: 'auto', display: 'block' }} />
          </div>
          <button
            onClick={() => setDrawerOpen(o => !o)}
            style={{ background: 'none', border: '1px solid #1E3A5F', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', color: '#8FA8C0', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <span style={{ fontSize: 16 }}>{drawerOpen ? '✕' : '☰'}</span>
            <span style={{ fontSize: 12 }}>{activeSection?.icon} {activeSection?.label}</span>
          </button>
        </div>
      )}

      {/* Mobile Drawer Overlay */}
      {isMobile && drawerOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', zIndex: 200 }} onClick={() => setDrawerOpen(false)}>
          <div style={{ width: 280, height: '100%', background: '#0a1118', borderRight: '1px solid #1E3A5F', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid #1E3A5F', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <img src="/logo-white.png" alt="McMullen Browne" style={{ height: 32, width: 'auto', display: 'block' }} />
                <div style={{ color: '#4A7EB5', fontSize: 10, textTransform: 'uppercase', letterSpacing: 1.5, marginTop: 6 }}>Employee Handbook</div>
              </div>
              <button onClick={() => setDrawerOpen(false)} style={{ background: 'none', border: 'none', color: '#8FA8C0', fontSize: 20, cursor: 'pointer', padding: 4 }}>✕</button>
            </div>
            <nav style={{ padding: '12px 0' }}>
              {SECTIONS.map(s => (
                <button key={s.id} onClick={() => handleNavClick(s.id)} style={{
                  width: '100%', textAlign: 'left', padding: '13px 20px',
                  background: active === s.id ? 'rgba(74,126,181,0.15)' : 'none',
                  border: 'none', borderLeft: `3px solid ${active === s.id ? '#4A7EB5' : 'transparent'}`,
                  color: active === s.id ? '#4A7EB5' : '#8FA8C0',
                  fontSize: 14, fontWeight: active === s.id ? 700 : 400,
                  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12,
                }}>
                  <span style={{ fontSize: 16 }}>{s.icon}</span>{s.label}
                </button>
              ))}
            </nav>
          </div>
        </div>
      )}

      {/* Desktop Sidebar */}
      {!isMobile && (
        <div style={{ width: 280, background: '#0a1118', borderRight: '1px solid #1E3A5F', position: 'sticky', top: 0, height: '100vh', overflowY: 'auto', flexShrink: 0 }}>
          <div style={{ padding: '24px 20px', borderBottom: '1px solid #1E3A5F' }}>
            <img src="/logo-white.png" alt="McMullen Browne" style={{ height: 38, width: 'auto', display: 'block', marginBottom: 8 }} />
            <div style={{ color: '#4A7EB5', fontSize: 11, textTransform: 'uppercase', letterSpacing: 1.5 }}>Employee Handbook</div>
            {standalone && (
              <div style={{ marginTop: 6, fontSize: 11, color: '#4A6580' }}>mcmullenbrownecrm.com/handbook</div>
            )}
          </div>
          <nav style={{ padding: '12px 0' }}>
            {SECTIONS.map(s => (
              <button key={s.id} onClick={() => setActive(s.id)} style={{
                width: '100%', textAlign: 'left', padding: '10px 20px',
                background: active === s.id ? 'rgba(74,126,181,0.15)' : 'none',
                border: 'none', borderLeft: `3px solid ${active === s.id ? '#4A7EB5' : 'transparent'}`,
                color: active === s.id ? '#4A7EB5' : '#8FA8C0',
                fontSize: 13, fontWeight: active === s.id ? 700 : 400,
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
              }}>
                <span>{s.icon}</span>{s.label}
              </button>
            ))}
          </nav>
        </div>
      )}

      {/* Content */}
      <style>{`
        .handbook-content p { margin: 0 0 18px; }
        .handbook-content ul, .handbook-content ol { margin: 0 0 18px; padding-left: 28px; }
        .handbook-content li { margin-bottom: 10px; }
        .handbook-content strong { color: #e2e8f0; }
      `}</style>
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
      <div className="handbook-content" style={{ width: '100%', maxWidth: isMobile ? '100%' : 1200, padding: isMobile ? '24px 16px 48px' : '56px 64px' }}>
        {active === 'welcome' && <Section title="Welcome to McMullen Browne Development LLC">
          <p>Welcome to the team. You've joined a company that's building something real in Delaware and the mid-Atlantic region. We're not the biggest — but we operate with precision, integrity, and a relentless commitment to doing things right.</p>
          <p>This handbook outlines our expectations, policies, and the standards that make McMullen Browne the company it is. Read it, understand it, and hold yourself to it. If you ever have questions, your Sales Manager's door is always open.</p>
          <p>We're glad you're here. Now let's get to work.</p>
          <InfoBox color="#4A7EB5" title="Your Sales Manager">
            <p>"This company runs on trust, accountability, and hustle. We do things the right way — for our customers, for each other, and for the communities we work in. That's the standard."</p>
          </InfoBox>
        </Section>}

        {active === 'company' && <Section title="Who We Are">
          <p>McMullen Browne Development LLC is a licensed and insured exterior contracting company based in Newark, Delaware. We specialize in:</p>
          <ul>
            <li><strong>Roofing</strong> — Insurance restoration work. We represent homeowners through the claim process and install premium TAMKO Titan XT roofing systems.</li>
            <li><strong>Asphalt Paving</strong> — Residential driveways, commercial parking lots, full installation and repair.</li>
            <li><strong>Concrete</strong> — Driveways, walkways, patios, and commercial flatwork.</li>
          </ul>
          <p><strong>Our licenses:</strong></p>
          <ul>
            <li>Delaware: DE-2026-000014249</li>
            <li>Maryland: 167775</li>
            <li>Pennsylvania: T002819</li>
          </ul>
          <p><strong>Our warranty:</strong> We back every job with a 3-Year Workmanship Warranty. If our work causes an issue within 3 years, we fix it — no questions asked.</p>
          <InfoBox color="#10B981" title="Our Values">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li><strong>Do it right the first time.</strong> We don't cut corners.</li>
              <li><strong>Own your work.</strong> If something goes wrong, we fix it.</li>
              <li><strong>Respect the customer.</strong> We're working in people's homes.</li>
              <li><strong>Be on time.</strong> Time is money — for us and for them.</li>
              <li><strong>Represent the brand.</strong> Every interaction is a reflection of McMullen Browne.</li>
            </ul>
          </InfoBox>
        </Section>}

        {active === 'employment' && <Section title="Employment Policies">
          <H3>At-Will Employment</H3>
          <p>Employment at McMullen Browne is at-will. Either party may end the employment relationship at any time, with or without cause or notice, subject to applicable Delaware law.</p>

          <H3>Work Schedule</H3>
          <p>Schedules are set by management and vary by role. Field staff should expect to work during daylight hours, Monday through Saturday. Storm events may require immediate deployment outside normal hours — all field staff are expected to be available during active storm seasons.</p>

          <H3>Attendance & Punctuality</H3>
          <p>Show up when you're scheduled. If you're going to be late or absent, contact your supervisor before your shift starts — not after. Repeated unexcused absences will result in disciplinary action up to and including termination.</p>

          <H3>Conduct Standards</H3>
          <ul>
            <li>Treat customers, teammates, and the public with respect at all times</li>
            <li>No profanity, aggressive behavior, or confrontation on job sites or in the field</li>
            <li>No use of personal devices for non-work purposes while on the clock at customer properties</li>
            <li>Any conduct that reflects negatively on McMullen Browne is grounds for disciplinary action</li>
          </ul>

          <H3>Background Checks & Drug Testing</H3>
          <p>All employees are subject to background check as a condition of hire. Random drug testing is conducted throughout employment. Post-incident testing may also be required. A positive result or refusal to test is grounds for immediate termination.</p>

          <H3>Non-Competition</H3>
          <p>For 6 months following separation from employment, you may not work for or operate a competing roofing, asphalt, concrete, or seal coat business within 50 miles of Newark, Delaware. You also may not solicit McMullen Browne customers or employees for 12 months following separation.</p>
        </Section>}

        {active === 'compensation' && <Section title="Compensation & Payroll">
          <H3>Pay Schedule</H3>
          <p>All employees are paid <strong>weekly</strong> via direct deposit through QuickBooks Online Payroll. Pay period runs Monday through Sunday, with payment processed the following week.</p>

          <H3>Pay Rates by Role</H3>
          <InfoBox color="#4A7EB5" title="Salesman — Field Sales Representative">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li><strong>Base:</strong> $15.00/hour</li>
              <li><strong>Performance Bonus:</strong> $300 per qualifying submission (complete 7-section checklist with photos + valid claim number)</li>
              <li><strong>Vehicle Allowance:</strong> $30/active field day</li>
              <li><strong>Overtime:</strong> 1.5x after 40 hours/week</li>
            </ul>
          </InfoBox>
          <InfoBox color="#8B5CF6" title="Estimator">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li><strong>Base:</strong> $15.00/hour</li>
              <li><strong>Commission:</strong> Percentage of each signed and completed estimate (asphalt, concrete, seal coat) — visible in the estimator app at time of estimate creation</li>
              <li><strong>Overtime:</strong> 1.5x after 40 hours/week</li>
            </ul>
          </InfoBox>
          <InfoBox color="#EC4899" title="Foreman">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li><strong>Base:</strong> $20.00/hour</li>
              <li><strong>Overtime:</strong> $30.00/hour after 40 hours/week</li>
            </ul>
          </InfoBox>

          <H3>Commission & Bonus Rules</H3>
          <p><strong>Salesman bonuses</strong> are paid weekly alongside regular pay for all qualifying submissions confirmed in the prior pay period. A submission qualifies when: (1) a complete 7-section checklist with all required photos is submitted via the app, and (2) a valid insurance claim number is documented.</p>
          <p><strong>Estimator commissions</strong> are paid upon job completion and final payment collection. If a job is cancelled before work begins, commission is forfeited.</p>

          <H3>Expense Reimbursement</H3>
          <p>Salesmen receive a flat $30/day vehicle allowance on active field days in lieu of mileage reimbursement. No other expense reimbursements are provided unless pre-approved in writing by management.</p>

          <H3>Pay Disputes</H3>
          <p>If you believe your pay is incorrect, contact your Sales Manager directly within 30 days of the pay date in question. Disputes raised after 30 days may not be correctable.</p>
        </Section>}

        {active === 'app' && <Section title="App Requirements">
          <p>The McMullen Browne mobile app is a <strong>mandatory work tool</strong> for all field staff. It is how we track leads, submit documentation, process payments, and run the business. Not using it properly directly impacts your pay.</p>

          <H3>Requirements</H3>
          <ul>
            <li>App must be installed and logged in before your first day in the field</li>
            <li>Your phone must have sufficient battery and data to use the app throughout your shift</li>
            <li>All lead pins must be dropped in real time — not at the end of the day</li>
            <li>Checklist photos must be taken on-site — staged or after-the-fact photos are not acceptable</li>
            <li>All documentation must be submitted the same day as the work</li>
          </ul>

          <H3>By Role</H3>
          <p><strong>Salesmen:</strong> Use the map to drop pins and track lead statuses. Submit the complete 7-section roof checklist with photos to earn the $300 bonus. Track commissions and standings on the leaderboard.</p>
          <p><strong>Estimators:</strong> Use the estimator app to build and present estimates, collect signatures, process deposits, and schedule jobs. All estimates must be created in the app — no paper estimates.</p>
          <p><strong>Foremen:</strong> Complete all documentation steps for every assigned job before end of day. The COC signature triggers the homeowner invoice — don't skip it.</p>

          <InfoBox color="#F59E0B" title="Important">
            <p>Failure to use the app properly — including missing photos, incomplete checklists, or undocumented work — may result in bonus/commission withholding for that submission until resolved.</p>
          </InfoBox>
        </Section>}

        {active === 'leads' && <Section title="Lead & Territory Rules">
          <p>These rules apply to field salesmen. Following them protects your commissions and keeps the team operating efficiently.</p>

          <H3>Pin Dropping Rules</H3>
          <ul>
            <li>Drop a pin for <strong>every door you knock</strong> — even if nobody answers. This creates your work record and protects your territory.</li>
            <li>Pins must be dropped at the time of the visit — not retrospectively.</li>
            <li>If a pin already exists for an address, do not knock that door. Someone from McMullen Browne has already visited.</li>
          </ul>

          <H3>Buddy System</H3>
          <p>Salesmen work in two-person teams. Split the street — one partner takes the left side, one takes the right. Communicate with your partner about appointments set so you can coordinate effectively.</p>

          <H3>Lead Status Updates</H3>
          <p>Update lead statuses in real time:</p>
          <ul>
            <li><strong>NH1/NH2/NH3</strong> — No answer, first/second/third attempt</li>
            <li><strong>GB</strong> — Firmly not interested</li>
            <li><strong>CB</strong> — Wants a callback — note the time</li>
            <li><strong>APP</strong> — Appointment set</li>
            <li><strong>LD</strong> — Active hot lead</li>
            <li><strong>SOLD</strong> — Checklist submitted + claim number obtained (requires claim # to unlock)</li>
          </ul>

          <H3>Territory Assignments</H3>
          <p>During storm deployments, management assigns specific neighborhoods or zip codes. During normal operations, you may work any area not actively covered by another team. When in doubt, ask management before entering a new area.</p>

          <H3>Storm Deployment</H3>
          <p>When a storm event hits the area, management will alert all teams to mobilize. Speed is critical — first teams on the street set the appointments. Be ready to deploy same-day when called.</p>
        </Section>}

        {active === 'estimates' && <Section title="Estimate Guidelines">
          <p>These guidelines apply to estimators. Your estimate is the customer's first impression of our pricing and professionalism — get it right.</p>

          <H3>Measurement Standards</H3>
          <ul>
            <li>Always measure on-site — never estimate by eye or from satellite imagery alone</li>
            <li>Break irregular areas into rectangles and add them in the app separately</li>
            <li>Include all areas: main driveway, apron, parking pad, walkways</li>
            <li>Note access issues, base conditions, and obstacles that affect scope</li>
          </ul>

          <H3>Pricing</H3>
          <p>Pricing is set by management in the app. Do not change base pricing without authorization. The 5% same-day discount is available as a closing tool — use it when the homeowner is deciding on the spot, not as a routine discount on every job.</p>

          <H3>Presenting the Estimate</H3>
          <ul>
            <li>Walk the property with the homeowner before showing the estimate</li>
            <li>Explain what you measured and why</li>
            <li>Present the total and the deposit requirement together</li>
            <li>Handle price objections with value — not just discounts</li>
          </ul>

          <H3>Signing & Deposits</H3>
          <p>All estimates must be signed digitally in the app. Never accept a verbal agreement. Collect the deposit at signing whenever possible — either by card capture in the app or via the payment link sent to the homeowner's email. The deposit schedules the job.</p>

          <H3>Commission Rules</H3>
          <p>Commission is earned when: (1) the estimate is signed, (2) the job is completed, and (3) final payment is collected. If a job is cancelled before work begins, commission is forfeited. Disputes must be raised within 30 days.</p>
        </Section>}

        {active === 'documentation' && <Section title="Documentation Standards">
          <p>These standards apply to foremen. The quality of your documentation directly affects the homeowner's experience, the company's legal protection, and your pay.</p>

          <H3>Required for Every Job</H3>
          <ol>
            <li><strong>Mobilization</strong> — Full crew photo (everyone visible, McMullen Browne shirts), dumpster placement, material delivery, equipment on-site</li>
            <li><strong>Before</strong> — Multiple angles of the full work area establishing baseline condition</li>
            <li><strong>In Progress</strong> — Active work shots showing installation stages</li>
            <li><strong>After</strong> — Completed work from same angles as before photos</li>
            <li><strong>End of Job</strong> — Clean site, equipment removed, street cleared</li>
            <li><strong>COC</strong> — Homeowner signature on Certificate of Completion</li>
          </ol>

          <H3>Photo Standards</H3>
          <ul>
            <li>In focus — blurry photos are not acceptable</li>
            <li>Well lit — no dark or overexposed shots</li>
            <li>Show the full area — wide shots first, then close-ups of detail work</li>
            <li>Minimum 3 photos per stage — more is always better</li>
          </ul>

          <H3>COC Process</H3>
          <p>Walk the homeowner through the completed work before presenting the COC. Address any concerns first. Never pressure a homeowner to sign if they have a legitimate issue — call your Sales Manager and resolve it. The COC triggers the automatic invoice, so it must be accurate.</p>

          <InfoBox color="#EF4444" title="Non-Negotiable">
            <p>Documentation must be completed the same day as the work. End-of-week submissions are not acceptable. Incomplete documentation may result in pay withheld for associated hours until resolved.</p>
          </InfoBox>
        </Section>}

        {active === 'dress' && <Section title="Dress Code & Uniforms">
          <H3>Required at All Times in the Field</H3>
          <ul>
            <li><strong>McMullen Browne shirt</strong> — Company-issued shirt must be worn on all field days. No personal shirts, no modified logos.</li>
            <li><strong>Work pants or shorts</strong> — Clean, no tears, no offensive graphics. Jeans acceptable.</li>
            <li><strong>Work boots</strong> — Hard-soled boots required for all field staff. No sneakers on job sites.</li>
            <li><strong>No visible offensive graphics, language, or imagery</strong> on any clothing.</li>
          </ul>

          <H3>Personal Appearance</H3>
          <ul>
            <li>Clean and presentable — you are representing the company at customer homes</li>
            <li>No excessive visible tattoos on the face or neck (existing tattoos are acceptable)</li>
            <li>Hair must be kept out of the face during work</li>
          </ul>

          <H3>Uniform Replacement</H3>
          <p>Company shirts are provided. If your shirt is damaged or worn out, contact management for a replacement. Do not continue wearing a damaged company shirt in the field.</p>
        </Section>}

        {active === 'vehicle' && <Section title="Vehicle & Equipment Policy">
          <H3>Personal Vehicles (Salesmen)</H3>
          <p>Salesmen use personal vehicles for field work and receive a $30/day vehicle allowance on active field days. You are responsible for:</p>
          <ul>
            <li>Maintaining your vehicle in safe, legal operating condition</li>
            <li>Carrying valid automobile insurance at all times</li>
            <li>Any traffic violations, accidents, or damage to your vehicle</li>
          </ul>
          <p>McMullen Browne is not responsible for damage to personal vehicles during work activities.</p>

          <H3>Company Vehicles & Equipment</H3>
          <p>Any company-owned vehicle or equipment must be operated safely and only by authorized personnel. Report any damage, mechanical issues, or accidents involving company equipment to management immediately. You are financially responsible for damage caused by negligence or misuse.</p>

          <H3>Driving Requirements</H3>
          <ul>
            <li>Valid driver's license required at all times</li>
            <li>No use of handheld devices while driving on company business</li>
            <li>No driving under the influence — ever. Immediate termination.</li>
          </ul>
        </Section>}

        {active === 'social' && <Section title="Social Media & Confidentiality">
          <H3>Social Media Policy</H3>
          <p>You may not post, share, or publish any of the following without express written approval from management:</p>
          <ul>
            <li>Customer names, addresses, or property photos</li>
            <li>Job site photos or videos</li>
            <li>Company pricing, contracts, or business operations</li>
            <li>Internal communications or company financials</li>
          </ul>
          <p>You may post about working at McMullen Browne in a positive, professional way. Before/after photos of completed jobs may be shared only with management approval and with customer consent.</p>
          <p>Statements that disparage, defame, or misrepresent the company, its employees, or its customers on any public platform are grounds for immediate termination.</p>

          <H3>Confidentiality</H3>
          <p>All customer data, lead data, pricing structures, business processes, and CRM information is the exclusive property of McMullen Browne Development LLC. You may not:</p>
          <ul>
            <li>Share customer contact information with anyone outside the company</li>
            <li>Use lead or customer data for personal benefit or competitive purposes</li>
            <li>Export, copy, or retain CRM data after separation from employment</li>
          </ul>
          <p>Confidentiality obligations survive separation from employment.</p>
        </Section>}

        {active === 'drug' && <Section title="Drug-Free Workplace">
          <p>McMullen Browne Development LLC maintains a strict drug-free workplace. This applies to all employees, contractors, and visitors on company job sites.</p>

          <H3>Policy</H3>
          <ul>
            <li>No use, possession, sale, or distribution of illegal drugs or controlled substances on the job or on company property</li>
            <li>No reporting to work under the influence of alcohol or any controlled substance</li>
            <li>Prescription medication that impairs job performance must be disclosed to management</li>
          </ul>

          <H3>Testing</H3>
          <ul>
            <li><strong>Pre-employment:</strong> Required for all new hires</li>
            <li><strong>Random:</strong> May occur at any time without prior notice</li>
            <li><strong>Post-incident:</strong> Required following any workplace accident or near-miss</li>
            <li><strong>For-cause:</strong> May be required if management has reasonable suspicion</li>
          </ul>

          <H3>Consequences</H3>
          <p>A positive drug test result or refusal to submit to testing is grounds for <strong>immediate termination</strong>. There are no exceptions.</p>
        </Section>}

        {active === 'safety' && <Section title="Safety Policy">
          <p>Safety is not optional. Every employee is responsible for working safely and for the safety of those around them.</p>

          <H3>Required PPE</H3>
          <ul>
            <li><strong>All field staff:</strong> Hard-soled work boots at all times on active job sites</li>
            <li><strong>Roofing crews:</strong> Fall protection harness required when working above 6 ft or near roof edges</li>
            <li><strong>Heavy equipment operation:</strong> Hard hat required</li>
          </ul>

          <H3>Site Setup</H3>
          <ul>
            <li>Dumpsters must not block traffic flow or emergency vehicle access</li>
            <li>Safety cones or caution tape required around active work areas near traffic or pedestrians</li>
            <li>All spills must be cleaned up immediately</li>
          </ul>

          <H3>Weather</H3>
          <p>Do not work on roofs during rain, high winds, or lightning. If conditions become unsafe during a job, stop work and contact management. Safety always takes priority over schedule.</p>

          <H3>Incident Reporting</H3>
          <p>Any workplace injury, near-miss, property damage, or unsafe condition must be reported to your Sales Manager immediately by phone — not at end of day, not by text, but by phone call. Failure to report promptly may affect workers' compensation eligibility and is grounds for disciplinary action.</p>

          <InfoBox color="#EF4444" title="Zero Tolerance">
            <p>Working under the influence of alcohol or drugs on a job site is grounds for immediate termination. No exceptions.</p>
          </InfoBox>
        </Section>}

        {active === 'help' && <Section title="How to Get Help">
          <p>McMullen Browne is a team. If you have questions, issues, or concerns — ask. Nobody gets penalized for asking questions. You do get penalized for making assumptions and getting it wrong.</p>

          <H3>Who to Contact for What</H3>
          <InfoBox color="#4A7EB5" title="Your Sales Manager">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Pay disputes or compensation questions</li>
              <li>Scope changes on active jobs</li>
              <li>Customer escalations or complaints</li>
              <li>Safety incidents</li>
              <li>Anything you're not sure about</li>
            </ul>
            <div style={{ marginTop: 10, fontWeight: 700 }}>
              📞 (302) 332-7573<br />
              ✉️ jarvis@mcmullenbrowne.com
            </div>
          </InfoBox>

          <H3>App Issues</H3>
          <p>If the McMullen Browne app isn't working, contact your Sales Manager directly. Don't skip documentation because the app is having issues — call it in and we'll resolve it together.</p>

          <H3>Payroll Questions</H3>
          <p>If your paycheck seems incorrect, contact your Sales Manager within 30 days. Have your hours, submissions, and any relevant documentation ready. Payroll is processed through QuickBooks — corrections are made in the following pay period.</p>

          <H3>HR Concerns</H3>
          <p>If you have a concern about workplace conduct, harassment, or a policy issue, bring it to your Sales Manager directly. All concerns are taken seriously and handled confidentially.</p>

          <div style={{ marginTop: 32, background: '#1A2B3C', borderRadius: 12, padding: 20, border: '1px solid #1E3A5F' }}>
            <div style={{ color: '#4A7EB5', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>McMullen Browne Development LLC</div>
            <div style={{ color: '#cbd5e1', fontSize: 14, lineHeight: 1.9 }}>
              📍 100 South Main St, Unit 109, Newark, DE 19711<br />
              📞 (302) 332-7573<br />
              ✉️ jarvis@mcmullenbrowne.com<br />
              📸 @mcmullenbrowne
            </div>
          </div>
        </Section>}
      </div></div>
    </div>
  );
}

// ─── Sub-components ───────────────────────────────────────────────────────────

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ fontSize: 19, lineHeight: 2.0, color: '#cbd5e1' }}>
      <h1 style={{ color: '#fff', fontSize: 40, fontWeight: 900, margin: '0 0 20px', borderBottom: '3px solid #4A7EB5', paddingBottom: 16 }}>{title}</h1>
      <div style={{ color: '#cbd5e1' }}>{children}</div>
    </div>
  );
}

function H3({ children }: { children: React.ReactNode }) {
  return <h3 style={{ color: '#4A7EB5', fontSize: 22, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, margin: '40px 0 14px', borderBottom: '1px solid #1E3A5F', paddingBottom: 8 }}>{children}</h3>;
}

function InfoBox({ title, color, children }: { title: string; color: string; children: React.ReactNode }) {
  return (
    <div style={{ background: color + '18', border: `2px solid ${color}55`, borderRadius: 14, padding: '24px 28px', margin: '28px 0' }}>
      <div style={{ color, fontWeight: 800, fontSize: 20, marginBottom: 14, textTransform: 'uppercase', letterSpacing: 0.5 }}>{title}</div>
      <div style={{ color: '#cbd5e1', fontSize: 19, lineHeight: 2.0 }}>{children}</div>
    </div>
  );
}
